/**
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version {{version}}
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
const P = function() {
  var f = window, A = {
    // placement of the popper
    placement: "bottom",
    gpuAcceleration: !0,
    // shift popper from its origin by the given amount of pixels (can be negative)
    offset: 0,
    // the element which will act as boundary of the popper
    boundariesElement: "viewport",
    // amount of pixel used to define a minimum distance between the boundaries and the popper
    boundariesPadding: 5,
    // popper will try to prevent overflow following this order,
    // by default, then, it could overflow on the left and on top of the boundariesElement
    preventOverflowOrder: ["left", "right", "top", "bottom"],
    // the behavior used by flip to change the placement of the popper
    flipBehavior: "flip",
    arrowElement: "[x-arrow]",
    arrowOffset: 0,
    // list of functions used to modify the offsets before they are applied to the popper
    modifiers: [
      "shift",
      "offset",
      "preventOverflow",
      "keepTogether",
      "arrow",
      "flip",
      "applyStyle"
    ],
    modifiersIgnored: [],
    forceAbsolute: !1
  };
  function l(t, e, r) {
    this._reference = t.jquery ? t[0] : t, this.state = {};
    var o = typeof e == "undefined" || e === null, i = e && Object.prototype.toString.call(e) === "[object Object]";
    return o || i ? this._popper = this.parse(i ? e : {}) : this._popper = e.jquery ? e[0] : e, this._options = Object.assign({}, A, r), this._options.modifiers = this._options.modifiers.map(
      function(s) {
        if (this._options.modifiersIgnored.indexOf(s) === -1)
          return s === "applyStyle" && this._popper.setAttribute("x-placement", this._options.placement), this.modifiers[s] || s;
      }.bind(this)
    ), this.state.position = this._getPosition(this._popper, this._reference), O(this._popper, { position: this.state.position, top: 0 }), this.update(), this._setupEventListeners(), this;
  }
  l.prototype.destroy = function() {
    return this._popper.removeAttribute("x-placement"), this._popper.style.left = "", this._popper.style.position = "", this._popper.style.top = "", this._popper.style[R("transform")] = "", this._removeEventListeners(), this._options.removeOnDestroy && this._popper.remove(), this;
  }, l.prototype.update = function() {
    var t = { instance: this, styles: {} };
    t.placement = this._options.placement, t._originalPlacement = this._options.placement, t.offsets = this._getOffsets(
      this._popper,
      this._reference,
      t.placement
    ), t.boundaries = this._getBoundaries(
      t,
      this._options.boundariesPadding,
      this._options.boundariesElement
    ), t = this.runModifiers(t, this._options.modifiers), typeof this.state.updateCallback == "function" && this.state.updateCallback(t);
  }, l.prototype.onCreate = function(t) {
    return t(this), this;
  }, l.prototype.onUpdate = function(t) {
    return this.state.updateCallback = t, this;
  }, l.prototype.parse = function(t) {
    var e = {
      tagName: "div",
      classNames: ["popper"],
      attributes: [],
      parent: f.document.body,
      content: "",
      contentType: "text",
      arrowTagName: "div",
      arrowClassNames: ["popper__arrow"],
      arrowAttributes: ["x-arrow"]
    };
    t = Object.assign({}, e, t);
    var r = f.document, o = r.createElement(t.tagName);
    if (n(o, t.classNames), p(o, t.attributes), t.contentType === "node" ? o.appendChild(
      t.content.jquery ? t.content[0] : t.content
    ) : t.contentType === "html" ? o.innerHTML = t.content : o.textContent = t.content, t.arrowTagName) {
      var i = r.createElement(t.arrowTagName);
      n(i, t.arrowClassNames), p(i, t.arrowAttributes), o.appendChild(i);
    }
    var s = t.parent.jquery ? t.parent[0] : t.parent;
    if (typeof s == "string") {
      if (s = r.querySelectorAll(t.parent), s.length > 1 && console.warn(
        "WARNING: the given `parent` query(" + t.parent + ") matched more than one element, the first one will be used"
      ), s.length === 0)
        throw "ERROR: the given `parent` doesn't exists!";
      s = s[0];
    }
    return s.length > 1 && !(s instanceof Element) && (console.warn(
      "WARNING: you have passed as parent a list of elements, the first one will be used"
    ), s = s[0]), s.appendChild(o), o;
    function n(a, h) {
      h.forEach(function(u) {
        a.classList.add(u);
      });
    }
    function p(a, h) {
      h.forEach(function(u) {
        a.setAttribute(
          u.split(":")[0],
          u.split(":")[1] || ""
        );
      });
    }
  }, l.prototype._getPosition = function(t, e) {
    if (y(e), this._options.forceAbsolute)
      return "absolute";
    var r = T(e);
    return r ? "fixed" : "absolute";
  }, l.prototype._getOffsets = function(t, e, r) {
    r = r.split("-")[0];
    var o = {};
    o.position = this.state.position;
    var i = o.position === "fixed", s = L(
      e,
      y(t),
      i
    ), n = x(t);
    return ["right", "left"].indexOf(r) !== -1 ? (o.top = s.top + s.height / 2 - n.height / 2, r === "left" ? o.left = s.left - n.width : o.left = s.right) : (o.left = s.left + s.width / 2 - n.width / 2, r === "top" ? o.top = s.top - n.height : o.top = s.bottom), o.width = n.width, o.height = n.height, {
      popper: o,
      reference: s
    };
  }, l.prototype._setupEventListeners = function() {
    if (this.state.updateBound = this.update.bind(this), f.addEventListener("resize", this.state.updateBound), this._options.boundariesElement !== "window") {
      var t = w(this._reference);
      (t === f.document.body || t === f.document.documentElement) && (t = f), t.addEventListener("scroll", this.state.updateBound), this.state.scrollTarget = t;
    }
  }, l.prototype._removeEventListeners = function() {
    f.removeEventListener("resize", this.state.updateBound), this._options.boundariesElement !== "window" && this.state.scrollTarget && (this.state.scrollTarget.removeEventListener(
      "scroll",
      this.state.updateBound
    ), this.state.scrollTarget = null), this.state.updateBound = null;
  }, l.prototype._getBoundaries = function(t, e, r) {
    var o = {}, i, s;
    if (r === "window") {
      var n = f.document.body, p = f.document.documentElement;
      s = Math.max(
        n.scrollHeight,
        n.offsetHeight,
        p.clientHeight,
        p.scrollHeight,
        p.offsetHeight
      ), i = Math.max(
        n.scrollWidth,
        n.offsetWidth,
        p.clientWidth,
        p.scrollWidth,
        p.offsetWidth
      ), o = {
        top: 0,
        right: i,
        bottom: s,
        left: 0
      };
    } else if (r === "viewport") {
      var a = y(this._popper), h = w(this._popper), u = M(a), d = function(g) {
        return g == document.body ? Math.max(
          document.documentElement.scrollTop,
          document.body.scrollTop
        ) : g.scrollTop;
      }, c = function(g) {
        return g == document.body ? Math.max(
          document.documentElement.scrollLeft,
          document.body.scrollLeft
        ) : g.scrollLeft;
      }, _ = t.offsets.popper.position === "fixed" ? 0 : d(h), m = t.offsets.popper.position === "fixed" ? 0 : c(h);
      o = {
        top: 0 - (u.top - _),
        right: f.document.documentElement.clientWidth - (u.left - m),
        bottom: f.document.documentElement.clientHeight - (u.top - _),
        left: 0 - (u.left - m)
      };
    } else
      y(this._popper) === r ? o = {
        top: 0,
        left: 0,
        right: r.clientWidth,
        bottom: r.clientHeight
      } : o = M(r);
    return o.left += e, o.right -= e, o.top = o.top + e, o.bottom = o.bottom - e, o;
  }, l.prototype.runModifiers = function(t, e, r) {
    var o = e.slice();
    return r !== void 0 && (o = this._options.modifiers.slice(
      0,
      N(this._options.modifiers, r)
    )), o.forEach(
      function(i) {
        C(i) && (t = i.call(this, t));
      }.bind(this)
    ), t;
  }, l.prototype.isModifierRequired = function(t, e) {
    var r = N(this._options.modifiers, t);
    return !!this._options.modifiers.slice(0, r).filter(function(o) {
      return o === e;
    }).length;
  }, l.prototype.modifiers = {}, l.prototype.modifiers.applyStyle = function(t) {
    var e = {
      position: t.offsets.popper.position
    }, r = Math.round(t.offsets.popper.left), o = Math.round(t.offsets.popper.top), i;
    return this._options.gpuAcceleration && (i = R("transform")) ? (e[i] = "translate3d(" + r + "px, " + o + "px, 0)", e.top = 0, e.left = 0) : (e.left = r, e.top = o), Object.assign(e, t.styles), O(this._popper, e), this._popper.setAttribute("x-placement", t.placement), this.isModifierRequired(
      this.modifiers.applyStyle,
      this.modifiers.arrow
    ) && t.offsets.arrow && O(t.arrowElement, t.offsets.arrow), t;
  }, l.prototype.modifiers.shift = function(t) {
    var e = t.placement, r = e.split("-")[0], o = e.split("-")[1];
    if (o) {
      var i = t.offsets.reference, s = v(t.offsets.popper), n = {
        y: {
          start: { top: i.top },
          end: { top: i.top + i.height - s.height }
        },
        x: {
          start: { left: i.left },
          end: { left: i.left + i.width - s.width }
        }
      }, p = ["bottom", "top"].indexOf(r) !== -1 ? "x" : "y";
      t.offsets.popper = Object.assign(
        s,
        n[p][o]
      );
    }
    return t;
  }, l.prototype.modifiers.preventOverflow = function(t) {
    var e = this._options.preventOverflowOrder, r = v(t.offsets.popper), o = {
      left: function() {
        var i = r.left;
        return r.left < t.boundaries.left && (i = Math.max(r.left, t.boundaries.left)), { left: i };
      },
      right: function() {
        var i = r.left;
        return r.right > t.boundaries.right && (i = Math.min(r.left, t.boundaries.right - r.width)), { left: i };
      },
      top: function() {
        var i = r.top;
        return r.top < t.boundaries.top && (i = Math.max(r.top, t.boundaries.top)), { top: i };
      },
      bottom: function() {
        var i = r.top;
        return r.bottom > t.boundaries.bottom && (i = Math.min(r.top, t.boundaries.bottom - r.height)), { top: i };
      }
    };
    return e.forEach(function(i) {
      t.offsets.popper = Object.assign(r, o[i]());
    }), t;
  }, l.prototype.modifiers.keepTogether = function(t) {
    var e = v(t.offsets.popper), r = t.offsets.reference, o = Math.floor;
    return e.right < o(r.left) && (t.offsets.popper.left = o(r.left) - e.width), e.left > o(r.right) && (t.offsets.popper.left = o(r.right)), e.bottom < o(r.top) && (t.offsets.popper.top = o(r.top) - e.height), e.top > o(r.bottom) && (t.offsets.popper.top = o(r.bottom)), t;
  }, l.prototype.modifiers.flip = function(t) {
    if (!this.isModifierRequired(
      this.modifiers.flip,
      this.modifiers.preventOverflow
    ))
      return console.warn(
        "WARNING: preventOverflow modifier is required by flip modifier in order to work, be sure to include it before flip!"
      ), t;
    if (t.flipped && t.placement === t._originalPlacement)
      return t;
    var e = t.placement.split("-")[0], r = E(e), o = t.placement.split("-")[1] || "", i = [];
    return this._options.flipBehavior === "flip" ? i = [e, r] : i = this._options.flipBehavior, i.forEach(
      function(s, n) {
        if (!(e !== s || i.length === n + 1)) {
          e = t.placement.split("-")[0], r = E(e);
          var p = v(t.offsets.popper), a = ["right", "bottom"].indexOf(e) !== -1;
          (a && Math.floor(t.offsets.reference[e]) > Math.floor(p[r]) || !a && Math.floor(t.offsets.reference[e]) < Math.floor(p[r])) && (t.flipped = !0, t.placement = i[n + 1], o && (t.placement += "-" + o), t.offsets.popper = this._getOffsets(
            this._popper,
            this._reference,
            t.placement
          ).popper, t = this.runModifiers(t, this._options.modifiers, this._flip));
        }
      }.bind(this)
    ), t;
  }, l.prototype.modifiers.offset = function(t) {
    var e = this._options.offset, r = t.offsets.popper;
    return t.placement.indexOf("left") !== -1 ? r.top -= e : t.placement.indexOf("right") !== -1 ? r.top += e : t.placement.indexOf("top") !== -1 ? r.left -= e : t.placement.indexOf("bottom") !== -1 && (r.left += e), t;
  }, l.prototype.modifiers.arrow = function(t) {
    var e = this._options.arrowElement, r = this._options.arrowOffset;
    if (typeof e == "string" && (e = this._popper.querySelector(e)), !e)
      return t;
    if (!this._popper.contains(e))
      return console.warn(
        "WARNING: `arrowElement` must be child of its popper element!"
      ), t;
    if (!this.isModifierRequired(
      this.modifiers.arrow,
      this.modifiers.keepTogether
    ))
      return console.warn(
        "WARNING: keepTogether modifier is required by arrow modifier in order to work, be sure to include it before arrow!"
      ), t;
    var o = {}, i = t.placement.split("-")[0], s = v(t.offsets.popper), n = t.offsets.reference, p = ["left", "right"].indexOf(i) !== -1, a = p ? "height" : "width", h = p ? "top" : "left", u = p ? "left" : "top", d = p ? "bottom" : "right", c = x(e)[a];
    n[d] - c < s[h] && (t.offsets.popper[h] -= s[h] - (n[d] - c)), n[h] + c > s[d] && (t.offsets.popper[h] += n[h] + c - s[d]);
    var _ = n[h] + (r || n[a] / 2 - c / 2), m = _ - s[h];
    return m = Math.max(Math.min(s[a] - c - 8, m), 8), o[h] = m, o[u] = "", t.offsets.arrow = o, t.arrowElement = e, t;
  };
  function x(t) {
    var e = t.style.display, r = t.style.visibility;
    t.style.display = "block", t.style.visibility = "hidden", t.offsetWidth;
    var o = f.getComputedStyle(t), i = parseFloat(o.marginTop) + parseFloat(o.marginBottom), s = parseFloat(o.marginLeft) + parseFloat(o.marginRight), n = {
      width: t.offsetWidth + s,
      height: t.offsetHeight + i
    };
    return t.style.display = e, t.style.visibility = r, n;
  }
  function E(t) {
    var e = { left: "right", right: "left", bottom: "top", top: "bottom" };
    return t.replace(/left|right|bottom|top/g, function(r) {
      return e[r];
    });
  }
  function v(t) {
    var e = Object.assign({}, t);
    return e.right = e.left + e.width, e.bottom = e.top + e.height, e;
  }
  function N(t, e) {
    var r = 0, o;
    for (o in t) {
      if (t[o] === e)
        return r;
      r++;
    }
    return null;
  }
  function b(t, e) {
    var r = f.getComputedStyle(t, null);
    return r[e];
  }
  function y(t) {
    var e = t.offsetParent;
    return e === f.document.body || !e ? f.document.documentElement : e;
  }
  function w(t) {
    var e = t.parentNode;
    return e ? e === f.document ? f.document.body.scrollTop || f.document.body.scrollLeft ? f.document.body : f.document.documentElement : ["scroll", "auto"].indexOf(
      b(e, "overflow")
    ) !== -1 || ["scroll", "auto"].indexOf(
      b(e, "overflow-x")
    ) !== -1 || ["scroll", "auto"].indexOf(
      b(e, "overflow-y")
    ) !== -1 ? e : w(t.parentNode) : t;
  }
  function T(t) {
    return t === f.document.body ? !1 : b(t, "position") === "fixed" ? !0 : t.parentNode ? T(t.parentNode) : t;
  }
  function O(t, e) {
    function r(o) {
      return o !== "" && !isNaN(parseFloat(o)) && isFinite(o);
    }
    Object.keys(e).forEach(function(o) {
      var i = "";
      ["width", "height", "top", "right", "bottom", "left"].indexOf(o) !== -1 && r(e[o]) && (i = "px"), t.style[o] = e[o] + i;
    });
  }
  function C(t) {
    var e = {};
    return t && e.toString.call(t) === "[object Function]";
  }
  function M(t) {
    var e = {
      width: t.offsetWidth,
      height: t.offsetHeight,
      left: t.offsetLeft,
      top: t.offsetTop
    };
    return e.right = e.left + e.width, e.bottom = e.top + e.height, e;
  }
  function j(t) {
    var e = t.getBoundingClientRect(), r = navigator.userAgent.indexOf("MSIE") != -1, o = r && t.tagName === "HTML" ? -t.scrollTop : e.top;
    return {
      left: e.left,
      top: o,
      right: e.right,
      bottom: e.bottom,
      width: e.right - e.left,
      height: e.bottom - o
    };
  }
  function L(t, e, r) {
    var o = j(t), i = j(e);
    if (r) {
      var s = w(e);
      i.top += s.scrollTop, i.bottom += s.scrollTop, i.left += s.scrollLeft, i.right += s.scrollLeft;
    }
    var n = {
      top: o.top - i.top,
      left: o.left - i.left,
      bottom: o.top - i.top + o.height,
      right: o.left - i.left + o.width,
      width: o.width,
      height: o.height
    };
    return n;
  }
  function R(t) {
    for (var e = ["", "ms", "webkit", "moz", "o"], r = 0; r < e.length; r++) {
      var o = e[r] ? e[r] + t.charAt(0).toUpperCase() + t.slice(1) : t;
      if (typeof f.document.body.style[o] != "undefined")
        return o;
    }
    return null;
  }
  return Object.assign || Object.defineProperty(Object, "assign", {
    enumerable: !1,
    configurable: !0,
    writable: !0,
    value: function(t) {
      if (t == null)
        throw new TypeError("Cannot convert first argument to object");
      for (var e = Object(t), r = 1; r < arguments.length; r++) {
        var o = arguments[r];
        if (o != null) {
          o = Object(o);
          for (var i = Object.keys(o), s = 0, n = i.length; s < n; s++) {
            var p = i[s], a = Object.getOwnPropertyDescriptor(o, p);
            a !== void 0 && a.enumerable && (e[p] = o[p]);
          }
        }
      }
      return e;
    }
  }), l;
};
export {
  P as default
};
